import cn from 'classnames';

import AutoBlurButton from 'components/common/AutoBlurButton';
import CaretLeft from 'components/icons/navigation/CaretLeft';
import CaretRight from 'components/icons/navigation/CaretRight';

const ScrollArrows = ({
  backButtonStyles = 'left-2',
  buttonStyles = 'h-10 w-10 -translate-y-10 top-1/2',
  forwardButtonStyles = 'right-2',
  iconStyles = 'iconMd',
  iconColorStyles = '',
  showPrev,
  showNext,
  scrollLeft,
  scrollRight,
}) => {
  const navButtonStyles =
    'absolute rounded-full bg-white-100 transition-all shadow-xl duration-200 ring-1 ring-charcoal-50 focus:outline-none';

  return (
    <>
      {showPrev && (
        <AutoBlurButton
          className={cn('hover:scale-105', navButtonStyles, buttonStyles, backButtonStyles)}
          onClick={scrollLeft}
        >
          <span className="sr">Previous</span>
          <CaretLeft className={cn(iconStyles, iconColorStyles, 'text-secondary')} />
        </AutoBlurButton>
      )}
      {showNext && (
        <AutoBlurButton
          className={cn('hover:scale-105', navButtonStyles, buttonStyles, forwardButtonStyles)}
          onClick={scrollRight}
        >
          <span className="sr">Next</span>
          <CaretRight className={cn(iconStyles, iconColorStyles, 'text-secondary')} />
        </AutoBlurButton>
      )}
    </>
  );
};

export default ScrollArrows;

ScrollArrows.propTypes = {
  backButtonStyles: PropTypes.string,
  buttonStyles: PropTypes.string,
  forwardButtonStyles: PropTypes.string,
  iconStyles: PropTypes.string,
  iconColorStyles: PropTypes.string,
  showPrev: PropTypes.bool.isRequired,
  showNext: PropTypes.bool.isRequired,
  scrollLeft: PropTypes.func.isRequired,
  scrollRight: PropTypes.func.isRequired,
};
